export default "__VITE_ASSET__Cltd1YAS__"